/* This view represents what the user can see when looking at their book clubs. It shows both the 
   joined active clubs, and the pending requests, if any. On this page, a user can also create
   a new book club. */

import { Calendar, BookOpen, Users, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import CreateClubPopUp from "../components/createClubPopUp";
import { useState } from "react";
import Loader from "../components/loader";
import { Send, OctagonX} from "lucide-react";


   export function MyClubsView(props){
      console.log("currentUserId:", props.currentUser.currentUser);
      console.log("pending requests", props.currentUser.userRequests);
      const navigate = useNavigate();
      const [showCreateClub, setShowCreateClub] = useState(false); 
      const myClubsId = Array.isArray(props.currentUser.userClubs) ? [...props.currentUser.userClubs] : [];
      //const myClubs = [...props.clubs];
      //const pendingClubs
      const currentUserId = props.currentUser.currentUser;
         const pendingRequests = Array.isArray(props.currentUser.userRequests)
            ? props.currentUser.userRequests.filter(req => !myClubsId.some(c => String(c) === String(req.clubId)))
            : [];
      
      function cancelPendingRequestCB(clubId){
         console.log("club id som skickas in", clubId)
         props.onCancelJoinRequest(clubId, currentUserId);
      }

      
      function navigateToClubPageCB(clubId){
         props.onNavigateToClub(clubId)
         navigate(`/myClubs/${clubId}`)
      }

          function renderPendingRequestCB(pending){
             const clubId = String(pending?.clubId ?? pending?.id);
             const knownClub = props.clubs?.[clubId] ?? {};
             const display = {
                clubId,
                name: pending?.name ?? knownClub.name ?? clubId,
                genre: pending?.genre ?? knownClub.genre ?? "",
                nofMembers: pending?.nofMembers ?? (Array.isArray(knownClub.members) ? knownClub.members.length : 0),
             };

             return <div key={display.clubId}
                  className="bg-white rounded-xl shadow-lg border border-blue-200 overflow-hidden">
                  <div className="p-6">
                    <div className="flex items-start justify-between mb-4">
                      <div>
                                    <h3 className="text-blue-900 mb-1">{display.name}</h3>
                                    <p className="text-blue-600">{display.genre}</p>
                      </div>
                      <div className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full">
                        Pending
                      </div>
                    </div>

                    <div className="flex items-center gap-2 text-blue-700 mb-4">
                      <Users className="w-4 h-4" />
                                 <span>{display.nofMembers} members</span>
                    </div>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                                    cancelPendingRequestCB(display.clubId);
                      }}
                      className="w-full py-2 text-sm font-medium leading-6 bg-red-200 text-red-700 !border border-red-300 !rounded-lg hover:bg-red-300 transition-all flex items-center justify-center gap-[1px]"
                    >
                      <OctagonX className="w-4 h-4 mr-2"/>
                     <span>Cancel Request</span>
                    </button>
                  </div>
                </div>

      }



      function renderClubsCB(clubId){

         const club = props?.clubs[clubId];


         //const club = myClubs.find(c => c.id === clubId); om ovan inte fungerar testa detta
         const isAdmin = club.adminId === currentUserId;
         const currentMember = club.members.find(m => m.userId === currentUserId);
         console.log(isAdmin)

         return <div key={clubId}
            onClick={()=>navigateToClubPageCB(clubId)}
            className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden hover:shadow-xl transition-all cursor-pointer relative">
               <div className="p-6">
                  {/* Header: Club name (+ Admin badge) */}
                  <div className="flex items-start justify-between mb-2 gap-2">
                     <h3 className="text-blue-900 leading-snug break-words max-w-[calc(100%-4rem)]">{club.name}</h3>
                       {isAdmin && (
                           <div className="shrink-0 px-3 py-1 bg-blue-500 text-white rounded-full">
                           Admin
                        </div>
                     )} 
                  </div>
                  <p className="text-blue-600 mb-4">{club.genre}</p>

                  {club.currentBook ? (
                     <>
                        <div className="mb-4">
                           <p className="text-blue-700 mb-1">Currently Reading:</p>
                              <div className="mb-3 p-3 bg-blue-50 rounded-lg flex items-center gap-2">
                                 <img 
                                    src={club.currentBook.bookImg}
                                    alt={club.currentBook.title}
                                    className="w-16 h-20 object-cover rounded"/>
                                 <div className="flex flex-col">
                                    <p className="text-blue-600/90 mb-1">{club.currentBook.title}</p>
                                    <p className="text-blue-600">
                                       <span className="text-blue-900">Written By: </span> 
                                       {club.currentBook.author}
                                    </p>
                                 </div>
                                 
                              </div>
                        </div>

                        {club.deadline && (
                           <div className="flex items-center gap-2 text-blue-700 mb-3">
                              <Calendar className="w-4 h-4"/>
                              <span>Deadline: {club.deadline}</span>
                           </div>
                        )}
                        {/* maybe your progress */}
                        {currentMember && currentMember.readingProgress != null && (
                           <div className="mb-3">
                              <div className="flex items-center justify-between mb-1">
                                 <span className="text-blue-700">Your Progress</span>
                                 <span className="text-blue-900">
                                    {currentMember?.readingProgress ?? 0} / {club.currentBook?.pages ?? 0} pages
                                 </span>
                              </div> 
                              <div className="w-full h-2 bg-blue-100 rounded-full overflow-hidden">
                                 <div 
                                    className="h-full bg-gradient-to-r from-blue-500 to-cyan-600"
                                    style={{ width:`${(((currentMember?.readingProgress ?? 0)/(club.currentBook?.pages || 1))*100)}%`}}>
                                 </div>
                              </div>
                           </div>
                        )}

                     </>
                  ): (
                     <div className="mb-3 p-4 bg-blue-50 rounded-lg flex items-center gap-2">
                        <BookOpen className="w-5 h-5 text-blue-500 -translate-y-[90%]" />
                        <p className="text-blue-700">No current book - vote for suggestions!</p>
                     </div>
                  )}

                  <div className="flex items-center gap-2 text-blue-700">
                     <Users className="w-4 h-4" />
                     <span>{club.members.length} {club.members.length === 1 ? "member" : "members"}</span>
                  </div> 
               </div>
            </div>        
      }



      return <div className="min-h-screen bg-sky-50">
         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="mb-6">
               <h1 className="text-blue-900 mb-2">My Book Clubs</h1>
               <p className="text-blue-700">Your reading communities</p>
            </div>

            {/* My Active Clubs */}
            <div className="mb-10">
               <h2 className="text-blue-900 mb-4">Active Clubs ({myClubsId.length})</h2>
               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  
                  { (myClubsId.length > 0) && ((props.clubsReady) ? myClubsId.filter(clubId => props.clubs[clubId]).map(renderClubsCB) : <Loader/> )}
               </div>
              {myClubsId.length === 0 && (
                  <div className="text-center py-16 bg-white rounded-xl !border border-blue-200"> 
                     <BookOpen className="w-16 h-16 text-blue-300 mx-auto mb-4" />
                     <p className="text-blue-600 mb-4">You haven't joined any book clubs yet</p>
                     <button
                        onClick={() => navigate('/findClubs')}
                        className="px-6 py-2 bg-gradient-to-r from-blue-500 to-cyan-600 text-white !rounded-lg hover:from-blue-600 hover:to-cyan-700 transition-all"
                     >
                        Find Book Clubs
                     </button>
                  </div>
              )}


            </div>
            {/* Pending requests */}
            {pendingRequests.length > 0 && (
               <div>
                  <h3 className="text-blue-900 mb-4">Pending Requests ({pendingRequests.length})</h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                     {pendingRequests.map(renderPendingRequestCB)}

                  </div>
               </div>
            )}
            
            


            {/* Create New Club Button */}
            <div className="mt-12">
               <button
                  onClick={() => setShowCreateClub(true)}
                  className="flex items-center gap-2 px-6 py-2 bg-gradient-to-r from-blue-500 to-cyan-600 text-white !rounded-lg hover:from-blue-600 hover:to-cyan-700 transition-all"
               >
                  <Plus className="w-4 h-4"/>
                  <span>Create New Club</span>
               </button>
            </div>

            {/* Create new club pop up */}
            <CreateClubPopUp 
               show={showCreateClub}
               setShow={setShowCreateClub}
               onCreateClub={props.onCreateClub}
               error= {props.clubError}
               clubsReady={props.clubsReady}/>
               
               
         </div>

         
      </div>

      

    
   }